import { observer } from "mobx-react-lite";
import { VirtualizedItemList } from "@/components/item-list";
import { NotesListPageListEmpty } from "./notes-list-page-list-empty";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

interface Props {
  isDragging?: boolean;
}

export const HomePageNotesList = observer<Props>(() => {
  const page = useTabPageStore("notesListPage");

  const handleEndReached = () => {
    if (page.itemRows.length < page.filters.params.limit) return;
    page.filters.increaseLimit();
  };

  if (page.hasNoItems) {
    return <NotesListPageListEmpty />;
  }

  return (
    <>
      {!page.isLoading && (
        <VirtualizedItemList
          enableArrowHighlightNavigation={true}
          enableHighlightedItemPreview={true}
          onOpenHighlightedItem={({ itemId, event }) => {
            if (!page.orderedItemIds.includes(itemId)) {
              return;
            }
            page.store.navigation.goToNote({ noteId: itemId, event });
          }}
          rows={page.itemRows}
          listState={page.listState}
          endReached={handleEndReached}
          scrollTop={page.scrollTop}
          setScrollTop={page.setScrollTop}
        />
      )}
      {page.listState.multiSelectUi}
    </>
  );
});
